import { render, staticRenderFns } from "./CreateBand.vue?vue&type=template&id=76fc07f6&scoped=true&"
import script from "./CreateBand.vue?vue&type=script&lang=js&"
export * from "./CreateBand.vue?vue&type=script&lang=js&"
import style0 from "./CreateBand.vue?vue&type=style&index=0&id=76fc07f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76fc07f6",
  null
  
)

export default component.exports